import React from 'react';
import { Icon } from './Icon.js';
export const IconRectLayoutGrid4Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M6.49512 5.5V11H2.75C1.23122 11 0 9.76878 0 8.25V5.5H6.49512Z", fill: "currentColor" }),
        React.createElement("path", { d: "M9.25 1C10.7688 1 12 2.23122 12 3.75V4H0V3.75C0 2.23122 1.23122 1 2.75 1H9.25Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M12 5.5V8.25C12 9.76878 10.7688 11 9.25 11H7.99512V5.5H12Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconRectLayoutGrid4Fill12.js.map